import { GlobalStyles } from 'module/ui/components/styles/global';
import { theme } from 'module/ui/styles/theme';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'queries';
import { PropsWithChildren } from 'react';
import { memo } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import translations from 'translations/en.json';

const locale = 'en';

export const AppContextProvider = memo(({ children }: PropsWithChildren) => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <IntlProvider
            locale={locale}
            messages={translations}
            fallbackOnEmptyString
            defaultLocale="en"
          >
            {children}
          </IntlProvider>
          <GlobalStyles />
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
});
AppContextProvider.displayName = 'AppContextProvider';
